import {ReloadButton} from '@flexinet/ui-components';
import {useQueryClient} from '@tanstack/react-query';

import {billableUnitsKeys} from '../hooks/useBillableUnitsQuery';

// Reload REFETCHES the loaded list. It used to call fetchRecords, which is "load the
// next page", so on the last page it did nothing at all (FNP-1881).
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    return (
        <ReloadButton
            onClick={() => queryClient.refetchQueries({queryKey: billableUnitsKeys.lists()})}
        />
    );
};
